// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'transform';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M6.696 8.928h4.464m-1.656 1.728L11.16 9 9.504 7.344M2.88 11.16a2.232 2.232 0 1 0 0-4.464 2.232 2.232 0 0 0 0 4.464zm12.528-4.32c-.072-.216-.288-.288-.504-.144a.155.155 0 0 0-.144.144l-1.872 3.312c-.072.144-.072.288 0 .432s.216.216.36.216h3.672c.144 0 .288-.072.36-.216s.072-.288 0-.432z'
  />
);

export const viewBox = '0 0 18 18';
